import $ from "jquery";
import Common from './common.js';
import DatePicker from './datepicker';
import {clearAllBodyScrollLocks, disableBodyScroll} from "body-scroll-lock";

const Pannel = {

    "pannels": document.querySelectorAll('.pannel__content'),

    "initPannel": function() {
        this.pannels = document.querySelectorAll('.pannel__content');

        if(this.pannels.length) {
            this.onTogglePannel();
        }
    },

    "onTogglePannel": function() {
        let self = this;
        let body = document.querySelector('body');

        $('.js-pannel').on('shown.bs.collapse', function () {
            self.setPannel(this);
            self.saveBodyPosition(body);
            body.classList.add('-pannel');

            // @todo: fix this function triggered by each click on the pannel__content
            // $('body').on("click", $(this), Common.hideCollapse);
            DatePicker.initPicker();
        });

        $('.js-pannel').on('hidden.bs.collapse', function () {
            //save body position before removing -pannel class on body
            let bodyTop = body.getBoundingClientRect().top;

            body.classList.remove('-pannel');
            body.style.top = "auto";

            // $('body').off("click",$(this), Common.hideCollapse);

            //avoids jump when position top set to auto
            window.scroll({
                top: -bodyTop,
            });
        });
    },

    "saveBodyPosition": function(body) {
        body.style.top = body.getBoundingClientRect().top + 'px';
    },

    "setPannel": function(pannel) {
        let self = this;

        let pannelContainer = pannel.closest('.js-pannelContainer');
        let panneltoggleBtn = pannelContainer.querySelector('.js-togglePannel');
        let pannelBackdrop = pannelContainer.querySelector('.js-backdrop');

        let btnIsInViewport = Common.checkIfInViewPort(panneltoggleBtn);
        let btnPosition = panneltoggleBtn.getBoundingClientRect();

        if(btnIsInViewport) {
            self.pannelHeight(pannel, pannelBackdrop, btnPosition);
        }

    },

    "pannelHeight": function(pannel, pannelBackdrop, btnPosition, body) {
        let btnPositionBottom = btnPosition.bottom;
        let btnPositionTop = btnPosition.top;

        pannel.style.height = window.innerHeight - btnPositionBottom + 'px';
        pannel.style.top = btnPositionBottom + 'px';
        pannelBackdrop.style.height = window.innerHeight - btnPositionTop + 'px';
        pannelBackdrop.style.top = btnPositionTop + 'px';


    },

    "updatePannel": function() {
        if(window.innerWidth < Common.mqBreakpoints.xl) {
            this.pannels.forEach(pannel => this.setPannel(pannel));
        } else {
            let body = document.querySelector('body');
            body.classList.remove('-pannel');

            let shownPannel = document.querySelector('.js-pannel.show');

            if(shownPannel) {
                shownPannel.style.height = 'auto';
                shownPannel.style.top = 'auto';
            }

        }
    }

};


export default Pannel;